export default __webpack_public_path__ + "static/media/contact-img.315a1156.jpg";